module.exports = __webpack_public_path__ + "img/powered5.1.1.5f6e89d3.jpg";